import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0802706d = () => interopDefault(import('../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _77873513 = () => interopDefault(import('../pages/cities/index.vue' /* webpackChunkName: "pages/cities/index" */))
const _17abea4e = () => interopDefault(import('../pages/contacto/index.vue' /* webpackChunkName: "pages/contacto/index" */))
const _6428875b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1bf06e81 = () => interopDefault(import('../pages/facebook-deletion/index.vue' /* webpackChunkName: "pages/facebook-deletion/index" */))
const _020d14f9 = () => interopDefault(import('../pages/finish_purchase/index.vue' /* webpackChunkName: "pages/finish_purchase/index" */))
const _798ebcca = () => interopDefault(import('../pages/nearme/index.vue' /* webpackChunkName: "pages/nearme/index" */))
const _8fc9688e = () => interopDefault(import('../pages/oxxo_order/index.vue' /* webpackChunkName: "pages/oxxo_order/index" */))
const _2ebdf914 = () => interopDefault(import('../pages/oxxo_reference/index.vue' /* webpackChunkName: "pages/oxxo_reference/index" */))
const _5325b4b2 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _60eeb997 = () => interopDefault(import('../pages/spotify_auth/index.vue' /* webpackChunkName: "pages/spotify_auth/index" */))
const _063e2aa7 = () => interopDefault(import('../pages/subscription/index.vue' /* webpackChunkName: "pages/subscription/index" */))
const _036ef818 = () => interopDefault(import('../pages/legal/license.vue' /* webpackChunkName: "pages/legal/license" */))
const _05b0d1e6 = () => interopDefault(import('../pages/legal/privacy_policy.vue' /* webpackChunkName: "pages/legal/privacy_policy" */))
const _4327723c = () => interopDefault(import('../pages/legal/terms_of_service.vue' /* webpackChunkName: "pages/legal/terms_of_service" */))
const _1e400aac = () => interopDefault(import('../pages/news/coronavirus.vue' /* webpackChunkName: "pages/news/coronavirus" */))
const _74fb85f7 = () => interopDefault(import('../pages/subscription/benefits.vue' /* webpackChunkName: "pages/subscription/benefits" */))
const _7a68c0fe = () => interopDefault(import('../pages/subscription/checkout.vue' /* webpackChunkName: "pages/subscription/checkout" */))
const _1877c570 = () => interopDefault(import('../pages/subscription/confirmation.vue' /* webpackChunkName: "pages/subscription/confirmation" */))
const _9f882e48 = () => interopDefault(import('../pages/subscription/terms.vue' /* webpackChunkName: "pages/subscription/terms" */))
const _1a8bf3ae = () => interopDefault(import('../pages/user/events/index.vue' /* webpackChunkName: "pages/user/events/index" */))
const _630ca90f = () => interopDefault(import('../pages/user/faves/index.vue' /* webpackChunkName: "pages/user/faves/index" */))
const _dbe80a9e = () => interopDefault(import('../pages/user/payment-methods/index.vue' /* webpackChunkName: "pages/user/payment-methods/index" */))
const _9f1eb91a = () => interopDefault(import('../pages/user/settings/index.vue' /* webpackChunkName: "pages/user/settings/index" */))
const _a2366526 = () => interopDefault(import('../pages/user/subscription/index.vue' /* webpackChunkName: "pages/user/subscription/index" */))
const _37be9f0a = () => interopDefault(import('../pages/auth/pop/google/index.vue' /* webpackChunkName: "pages/auth/pop/google/index" */))
const _77aeeb70 = () => interopDefault(import('../pages/user/payment-methods/subscription_payment_methods.vue' /* webpackChunkName: "pages/user/payment-methods/subscription_payment_methods" */))
const _2407625f = () => interopDefault(import('../pages/email/verification/_email/_userWebId/_token/index.vue' /* webpackChunkName: "pages/email/verification/_email/_userWebId/_token/index" */))
const _3c814985 = () => interopDefault(import('../pages/subscription/cancel/_userWebId/_subscriptionId/_token/index.vue' /* webpackChunkName: "pages/subscription/cancel/_userWebId/_subscriptionId/_token/index" */))
const _1fae43aa = () => interopDefault(import('../pages/book/_search/index.vue' /* webpackChunkName: "pages/book/_search/index" */))
const _21330638 = () => interopDefault(import('../pages/checkout/_ticket_group_id/index.vue' /* webpackChunkName: "pages/checkout/_ticket_group_id/index" */))
const _057bd888 = () => interopDefault(import('../pages/reset-password/_token/index.vue' /* webpackChunkName: "pages/reset-password/_token/index" */))
const _3849151d = () => interopDefault(import('../pages/results/_name/index.vue' /* webpackChunkName: "pages/results/_name/index" */))
const _75b439b4 = () => interopDefault(import('../pages/e/_name/_id.vue' /* webpackChunkName: "pages/e/_name/_id" */))
const _170ac7a9 = () => interopDefault(import('../pages/book/_search/_venue_date/_event_id/index.vue' /* webpackChunkName: "pages/book/_search/_venue_date/_event_id/index" */))
const _e7d401c6 = () => interopDefault(import('../pages/cities/_parent/_category_city/_city.vue' /* webpackChunkName: "pages/cities/_parent/_category_city/_city" */))
const _7285e8fd = () => interopDefault(import('../pages/get_promo/_name/_firstName/_lastName/_email/index.vue' /* webpackChunkName: "pages/get_promo/_name/_firstName/_lastName/_email/index" */))
const _5a889bd5 = () => interopDefault(import('../pages/_parent/_category_city/_city.vue' /* webpackChunkName: "pages/_parent/_category_city/_city" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _0802706d,
    name: "app___en___default"
  }, {
    path: "/cities",
    component: _77873513,
    name: "cities___en___default"
  }, {
    path: "/contacto",
    component: _17abea4e,
    name: "contacto___en___default"
  }, {
    path: "/en",
    component: _6428875b,
    name: "index___en"
  }, {
    path: "/es",
    component: _6428875b,
    name: "index___es"
  }, {
    path: "/facebook-deletion",
    component: _1bf06e81,
    name: "facebook-deletion___en___default"
  }, {
    path: "/finish_purchase",
    component: _020d14f9,
    name: "finish_purchase___en___default"
  }, {
    path: "/nearme",
    component: _798ebcca,
    name: "nearme___en___default"
  }, {
    path: "/oxxo_order",
    component: _8fc9688e,
    name: "oxxo_order___en___default"
  }, {
    path: "/oxxo_reference",
    component: _2ebdf914,
    name: "oxxo_reference___en___default"
  }, {
    path: "/search",
    component: _5325b4b2,
    name: "search___en___default"
  }, {
    path: "/spotify_auth",
    component: _60eeb997,
    name: "spotify_auth___en___default"
  }, {
    path: "/subscription",
    component: _063e2aa7,
    name: "subscription___en___default"
  }, {
    path: "/en/app",
    component: _0802706d,
    name: "app___en"
  }, {
    path: "/en/cities",
    component: _77873513,
    name: "cities___en"
  }, {
    path: "/en/contacto",
    component: _17abea4e,
    name: "contacto___en"
  }, {
    path: "/en/facebook-deletion",
    component: _1bf06e81,
    name: "facebook-deletion___en"
  }, {
    path: "/en/finish_purchase",
    component: _020d14f9,
    name: "finish_purchase___en"
  }, {
    path: "/en/nearme",
    component: _798ebcca,
    name: "nearme___en"
  }, {
    path: "/en/oxxo_order",
    component: _8fc9688e,
    name: "oxxo_order___en"
  }, {
    path: "/en/oxxo_reference",
    component: _2ebdf914,
    name: "oxxo_reference___en"
  }, {
    path: "/en/search",
    component: _5325b4b2,
    name: "search___en"
  }, {
    path: "/en/spotify_auth",
    component: _60eeb997,
    name: "spotify_auth___en"
  }, {
    path: "/en/subscription",
    component: _063e2aa7,
    name: "subscription___en"
  }, {
    path: "/es/app",
    component: _0802706d,
    name: "app___es"
  }, {
    path: "/es/cities",
    component: _77873513,
    name: "cities___es"
  }, {
    path: "/es/contacto",
    component: _17abea4e,
    name: "contacto___es"
  }, {
    path: "/es/facebook-deletion",
    component: _1bf06e81,
    name: "facebook-deletion___es"
  }, {
    path: "/es/finish_purchase",
    component: _020d14f9,
    name: "finish_purchase___es"
  }, {
    path: "/es/nearme",
    component: _798ebcca,
    name: "nearme___es"
  }, {
    path: "/es/oxxo_order",
    component: _8fc9688e,
    name: "oxxo_order___es"
  }, {
    path: "/es/oxxo_reference",
    component: _2ebdf914,
    name: "oxxo_reference___es"
  }, {
    path: "/es/search",
    component: _5325b4b2,
    name: "search___es"
  }, {
    path: "/es/spotify_auth",
    component: _60eeb997,
    name: "spotify_auth___es"
  }, {
    path: "/es/subscription",
    component: _063e2aa7,
    name: "subscription___es"
  }, {
    path: "/legal/license",
    component: _036ef818,
    name: "legal-license___en___default"
  }, {
    path: "/legal/privacy_policy",
    component: _05b0d1e6,
    name: "legal-privacy_policy___en___default"
  }, {
    path: "/legal/terms_of_service",
    component: _4327723c,
    name: "legal-terms_of_service___en___default"
  }, {
    path: "/news/coronavirus",
    component: _1e400aac,
    name: "news-coronavirus___en___default"
  }, {
    path: "/subscription/benefits",
    component: _74fb85f7,
    name: "subscription-benefits___en___default"
  }, {
    path: "/subscription/checkout",
    component: _7a68c0fe,
    name: "subscription-checkout___en___default"
  }, {
    path: "/subscription/confirmation",
    component: _1877c570,
    name: "subscription-confirmation___en___default"
  }, {
    path: "/subscription/terms",
    component: _9f882e48,
    name: "subscription-terms___en___default"
  }, {
    path: "/user/events",
    component: _1a8bf3ae,
    name: "user-events___en___default"
  }, {
    path: "/user/faves",
    component: _630ca90f,
    name: "user-faves___en___default"
  }, {
    path: "/user/payment-methods",
    component: _dbe80a9e,
    name: "user-payment-methods___en___default"
  }, {
    path: "/user/settings",
    component: _9f1eb91a,
    name: "user-settings___en___default"
  }, {
    path: "/user/subscription",
    component: _a2366526,
    name: "user-subscription___en___default"
  }, {
    path: "/auth/pop/google",
    component: _37be9f0a,
    name: "auth-pop-google___en___default"
  }, {
    path: "/en/legal/license",
    component: _036ef818,
    name: "legal-license___en"
  }, {
    path: "/en/legal/privacy_policy",
    component: _05b0d1e6,
    name: "legal-privacy_policy___en"
  }, {
    path: "/en/legal/terms_of_service",
    component: _4327723c,
    name: "legal-terms_of_service___en"
  }, {
    path: "/en/news/coronavirus",
    component: _1e400aac,
    name: "news-coronavirus___en"
  }, {
    path: "/en/subscription/benefits",
    component: _74fb85f7,
    name: "subscription-benefits___en"
  }, {
    path: "/en/subscription/checkout",
    component: _7a68c0fe,
    name: "subscription-checkout___en"
  }, {
    path: "/en/subscription/confirmation",
    component: _1877c570,
    name: "subscription-confirmation___en"
  }, {
    path: "/en/subscription/terms",
    component: _9f882e48,
    name: "subscription-terms___en"
  }, {
    path: "/en/user/events",
    component: _1a8bf3ae,
    name: "user-events___en"
  }, {
    path: "/en/user/faves",
    component: _630ca90f,
    name: "user-faves___en"
  }, {
    path: "/en/user/payment-methods",
    component: _dbe80a9e,
    name: "user-payment-methods___en"
  }, {
    path: "/en/user/settings",
    component: _9f1eb91a,
    name: "user-settings___en"
  }, {
    path: "/en/user/subscription",
    component: _a2366526,
    name: "user-subscription___en"
  }, {
    path: "/es/legal/license",
    component: _036ef818,
    name: "legal-license___es"
  }, {
    path: "/es/legal/privacy_policy",
    component: _05b0d1e6,
    name: "legal-privacy_policy___es"
  }, {
    path: "/es/legal/terms_of_service",
    component: _4327723c,
    name: "legal-terms_of_service___es"
  }, {
    path: "/es/news/coronavirus",
    component: _1e400aac,
    name: "news-coronavirus___es"
  }, {
    path: "/es/subscription/benefits",
    component: _74fb85f7,
    name: "subscription-benefits___es"
  }, {
    path: "/es/subscription/checkout",
    component: _7a68c0fe,
    name: "subscription-checkout___es"
  }, {
    path: "/es/subscription/confirmation",
    component: _1877c570,
    name: "subscription-confirmation___es"
  }, {
    path: "/es/subscription/terms",
    component: _9f882e48,
    name: "subscription-terms___es"
  }, {
    path: "/es/user/events",
    component: _1a8bf3ae,
    name: "user-events___es"
  }, {
    path: "/es/user/faves",
    component: _630ca90f,
    name: "user-faves___es"
  }, {
    path: "/es/user/payment-methods",
    component: _dbe80a9e,
    name: "user-payment-methods___es"
  }, {
    path: "/es/user/settings",
    component: _9f1eb91a,
    name: "user-settings___es"
  }, {
    path: "/es/user/subscription",
    component: _a2366526,
    name: "user-subscription___es"
  }, {
    path: "/user/payment-methods/subscription_payment_methods",
    component: _77aeeb70,
    name: "user-payment-methods-subscription_payment_methods___en___default"
  }, {
    path: "/en/auth/pop/google",
    component: _37be9f0a,
    name: "auth-pop-google___en"
  }, {
    path: "/en/user/payment-methods/subscription_payment_methods",
    component: _77aeeb70,
    name: "user-payment-methods-subscription_payment_methods___en"
  }, {
    path: "/es/auth/pop/google",
    component: _37be9f0a,
    name: "auth-pop-google___es"
  }, {
    path: "/es/user/payment-methods/subscription_payment_methods",
    component: _77aeeb70,
    name: "user-payment-methods-subscription_payment_methods___es"
  }, {
    path: "/",
    component: _6428875b,
    name: "index___en___default"
  }, {
    path: "/en/email/verification/:email?/:userWebId?/:token",
    component: _2407625f,
    name: "email-verification-email-userWebId-token___en"
  }, {
    path: "/en/subscription/cancel/:userWebId?/:subscriptionId?/:token",
    component: _3c814985,
    name: "subscription-cancel-userWebId-subscriptionId-token___en"
  }, {
    path: "/es/email/verification/:email?/:userWebId?/:token",
    component: _2407625f,
    name: "email-verification-email-userWebId-token___es"
  }, {
    path: "/es/subscription/cancel/:userWebId?/:subscriptionId?/:token",
    component: _3c814985,
    name: "subscription-cancel-userWebId-subscriptionId-token___es"
  }, {
    path: "/en/book/:search",
    component: _1fae43aa,
    name: "book-search___en"
  }, {
    path: "/en/checkout/:ticket_group_id",
    component: _21330638,
    name: "checkout-ticket_group_id___en"
  }, {
    path: "/en/reset-password/:token",
    component: _057bd888,
    name: "reset-password-token___en"
  }, {
    path: "/en/results/:name",
    component: _3849151d,
    name: "results-name___en"
  }, {
    path: "/es/book/:search",
    component: _1fae43aa,
    name: "book-search___es"
  }, {
    path: "/es/checkout/:ticket_group_id",
    component: _21330638,
    name: "checkout-ticket_group_id___es"
  }, {
    path: "/es/reset-password/:token",
    component: _057bd888,
    name: "reset-password-token___es"
  }, {
    path: "/es/results/:name",
    component: _3849151d,
    name: "results-name___es"
  }, {
    path: "/en/e/:name?/:id?",
    component: _75b439b4,
    name: "e-name-id___en"
  }, {
    path: "/es/e/:name?/:id?",
    component: _75b439b4,
    name: "e-name-id___es"
  }, {
    path: "/email/verification/:email?/:userWebId?/:token",
    component: _2407625f,
    name: "email-verification-email-userWebId-token___en___default"
  }, {
    path: "/en/book/:search?/:venue_date/:event_id",
    component: _170ac7a9,
    name: "book-search-venue_date-event_id___en"
  }, {
    path: "/en/cities/:parent/:category_city?/:city?",
    component: _e7d401c6,
    name: "cities-parent-category_city-city___en"
  }, {
    path: "/es/book/:search?/:venue_date/:event_id",
    component: _170ac7a9,
    name: "book-search-venue_date-event_id___es"
  }, {
    path: "/es/cities/:parent/:category_city?/:city?",
    component: _e7d401c6,
    name: "cities-parent-category_city-city___es"
  }, {
    path: "/subscription/cancel/:userWebId?/:subscriptionId?/:token",
    component: _3c814985,
    name: "subscription-cancel-userWebId-subscriptionId-token___en___default"
  }, {
    path: "/en/get_promo/:name?/:firstName?/:lastName?/:email",
    component: _7285e8fd,
    name: "get_promo-name-firstName-lastName-email___en"
  }, {
    path: "/es/get_promo/:name?/:firstName?/:lastName?/:email",
    component: _7285e8fd,
    name: "get_promo-name-firstName-lastName-email___es"
  }, {
    path: "/book/:search",
    component: _1fae43aa,
    name: "book-search___en___default"
  }, {
    path: "/checkout/:ticket_group_id",
    component: _21330638,
    name: "checkout-ticket_group_id___en___default"
  }, {
    path: "/reset-password/:token",
    component: _057bd888,
    name: "reset-password-token___en___default"
  }, {
    path: "/results/:name",
    component: _3849151d,
    name: "results-name___en___default"
  }, {
    path: "/e/:name?/:id?",
    component: _75b439b4,
    name: "e-name-id___en___default"
  }, {
    path: "/book/:search?/:venue_date/:event_id",
    component: _170ac7a9,
    name: "book-search-venue_date-event_id___en___default"
  }, {
    path: "/cities/:parent/:category_city?/:city?",
    component: _e7d401c6,
    name: "cities-parent-category_city-city___en___default"
  }, {
    path: "/en/:parent/:category_city?/:city?",
    component: _5a889bd5,
    name: "parent-category_city-city___en"
  }, {
    path: "/es/:parent/:category_city?/:city?",
    component: _5a889bd5,
    name: "parent-category_city-city___es"
  }, {
    path: "/get_promo/:name?/:firstName?/:lastName?/:email",
    component: _7285e8fd,
    name: "get_promo-name-firstName-lastName-email___en___default"
  }, {
    path: "/:parent/:category_city?/:city?",
    component: _5a889bd5,
    name: "parent-category_city-city___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
